import { apiGet, apiPost } from "./client";
import type { SessionUser, LoginResponse } from "@shared/types/auth";

export async function login(username: string, password: string): Promise<SessionUser> {
  const data = await apiPost<LoginResponse>("/login", { username, password });
  return data.user;
}

export async function signup(email: string, password: string, displayName?: string): Promise<{ user: SessionUser }> {
  return apiPost<{ user: SessionUser }>("/signup", { email, password, display_name: displayName });
}

export async function logout(): Promise<void> {
  await apiGet<{ message: string }>("/logout");
}

export async function getSession(): Promise<SessionUser> {
  const data = await apiGet<{ user: SessionUser }>("/api/session");
  return data.user;
}

export async function getVerifyStatus(): Promise<{ verified: boolean }> {
  return apiGet<{ verified: boolean }>("/api/verify-status");
}

export async function saveOnboardingCredentials(
  credentials: { red61_username: string; red61_email: string; label?: string; password?: string }[]
): Promise<{ credentials: any[] }> {
  return apiPost<{ credentials: any[] }>("/api/onboarding/credentials", { credentials });
}

export async function getOnboardingStatus(): Promise<{
  email_verified: boolean;
  has_credentials: boolean;
  credential_count: number;
}> {
  return apiGet<any>("/api/onboarding/status");
}
